var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidenav-container"},[_c('transition',{attrs:{"name":"slide-side"}},[(_vm.toggleSidebar)?_c('div',{staticClass:"sidenav"},[_c('AppLinkSideBar',{staticClass:"sidebar-link"}),_c('TogglerLang')],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }